import React from 'react';

import { compose } from '../../core';

// import { withToolById } from './ToolOperations';
import { withApollo } from '@apollo/client/react/hoc';
import { TOOL_BY_ID_OPTIMIZED } from 'modules/tool/graphql/ToolByidOptimized.gql';
import SideBulbToolView from '../Components/SideBulbToolView';

const SideBulbToolContainer = props => {
  
  const {client, toolReturn, tool_id}=props
  const [getToolById,setToolData]= React.useState()

  const [loading,setloading]= React.useState(true)
  
  const withToolById = async (value) => {
      let id = value;
      const { data } = await client.query({
          query: TOOL_BY_ID_OPTIMIZED,
          variables: { toolId: Number(id) },
          fetchPolicy: 'network-only'
      });
      toolReturn(data?.getToolById)
      if(data?.getToolById){   
        setToolData(data?.getToolById)
        setloading(false)
      }
      setloading(false)
  }

  React.useEffect(()=>{
    if(tool_id){
        withToolById(tool_id)
    }
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[tool_id])

  return (
    <>
    {getToolById!=null&&<SideBulbToolView {...props} getToolById={getToolById} loading={loading}/>}
    </>
  );
};

export default compose(withApollo)(SideBulbToolContainer);
